import { Icon, IconText, Table } from "trunx";
import { ISensor } from "./models/Sensors";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { observer } from "mobx-react-lite";
import { useLocaleContext } from "./contexts/LocaleContext";
import useFindSensors from "./hooks/useFindSensor";
import { isPrecipSensor } from "./models/PrecipSensor";
import { useRootStore } from "./models/Root";
import BookmarkStar from "./shared/BookmarkStar";

const FindTable = observer(() => {
  const {
    dict: {
      panel: { find: dict },
    },
  } = useLocaleContext();

  const {
    sensors: { setSensor },
    menus: { find, setFind },
    isMobile
  } = useRootStore();

  const results = useFindSensors(find);

  const resultRow = (result: Fuzzysort.KeyResult<ISensor>) => {
    const sensor = result.obj;
    const { id, humanId, site } = sensor;

    const onClick = () => {
      setFind("");
      setSensor(sensor, "summary", !isMobile);
    };
    return (
      <tr key={id} style={{ cursor: "pointer" }}>
        <td>
          <BookmarkStar sensor={sensor} />
        </td>
        <td>{site}</td>
        <td>{humanId || ''}</td>
        <td className="sensor-type">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
          <IconText onClick={onClick}>
            {isPrecipSensor(sensor) ? dict.precip : dict.stream}
            <Icon>
              <FontAwesomeIcon icon="external-link-alt"></FontAwesomeIcon>
            </Icon>
          </IconText>
        </td>
      </tr>
    );
  };

  if (results === undefined) {
    return <></>;
  }

  return (
    <Table bulma="is-fullwidth" className="find-table">
      <tbody>
        <tr>
          <th colSpan={2}>{dict.name}</th>
          <th colSpan={2}>ID</th>
        </tr>
        {results.map(resultRow)}
      </tbody>
    </Table>
  );
});

export default FindTable